import React from 'react';
import { CircularProgress, Container } from '@mui/material';

const LoadingSpinner = ({ size = 40, color = '#000' }) => {
  return (
    <Container
      maxWidth="lg"
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}
    >
      <CircularProgress sx={{ color, size }} />
    </Container>
  );
};

export default LoadingSpinner;
